import { Box, Paper, Typography } from '@mui/material';
import { APP_NAME } from '../../app/theme';
import { PageHeader } from '../../components/PageHeader';

/**
 * Support (release switch `support-page`). The reference's page has the vendor's support address,
 * manuals and a troubleshooting FAQ, which are not copied; these answers are 212Ez's own and point
 * at its screens.
 */
const FAQ: Array<[question: string, answer: string[]]> = [
  [
    'A line cannot make or receive calls',
    [
      'Open the customer and check the account status: a Suspended or Inactive line has no service.',
      'Open Modify > Features and Services and use Query HLR to ask the carrier what the line is doing.',
      'If the SIM is damaged, use ESN/SIM Change with the reason for a bad SIM.',
    ],
  ],
  [
    'A line cannot use data',
    [
      'Check the plan in Line Information: Plan Details shows the data the plan includes.',
      'Add Data Topup adds data to the line when the allowance is used up.',
      'Usage shows what the carrier has counted for the line.',
    ],
  ],
  [
    'An order is waiting for shipment',
    [
      'The Shipping Queue lists orders that wait for a SIM; Order Fulfillment gives the order its SIM and Scan ESN/SIM for shipment sends it.',
    ],
  ],
  [
    'A number should move from another provider',
    [
      'Existing Subscriber Portin brings the number onto the customer’s line; the port-in lists show where the request stands.',
    ],
  ],
  [
    'Something does not work as expected',
    [
      'Note what you did and when, then contact your administrator: the REST API Log and the customer’s Activity Log show what the system did.',
    ],
  ],
];

export function SupportPage() {
  return (
    <Box>
      <PageHeader title="Support" />
      <Paper variant="outlined" sx={{ p: 2, mb: 1.5 }}>
        <Typography sx={{ fontWeight: 600 }}>Who to contact</Typography>
        <Typography>
          For help with {APP_NAME}, contact your administrator. They can open every screen, see the
          logs and change the settings.
        </Typography>
      </Paper>
      <Paper variant="outlined" component="section" aria-label="FAQ" sx={{ p: 2 }}>
        <Typography variant="h3" component="h2" sx={{ mb: 1 }}>
          FAQ
        </Typography>
        {FAQ.map(([question, answer]) => (
          <Box key={question} sx={{ mb: 1.5 }}>
            <Typography sx={{ fontWeight: 600 }}>{question}</Typography>
            <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
              {answer.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </Box>
          </Box>
        ))}
      </Paper>
    </Box>
  );
}
